import { createAction, props } from '@ngrx/store';
import { IPendingInvitedEmployeesQuickSearchQueryRequest } from '../../../shared/models/shared.model';

export const loadDeleteInvites = createAction(
  '[DeleteInvite] Load DeleteInvites',
  props<{
    businessId: string;
    businessInviteId: string;
    pendingInviteModel: IPendingInvitedEmployeesQuickSearchQueryRequest;
    groupUserRoleIds: string[];
  }>()
);

export const loadDeleteInvitesSuccess = createAction('[DeleteInvite] Load DeleteInvites Success', props<{ response: string }>());

export const loadDeleteInvitesFailure = createAction('[DeleteInvite] Load DeleteInvites Failure', props<{ error: Error | any }>());
